// What processing made of a submitted update, as the BD reads it (TX-US-0029): whether it is
// still being worked on, and how to name what came back. Pure functions; the cards are
// HubHistory.jsx.

// How long a submitted update is worth asking about again. Processing takes a minute or two; past
// this, a session still waiting is waiting on something a reload will not fix.
export const REFRESH_FOR_MS = 15 * 60 * 1000;
export const REFRESH_EVERY_MS = 10_000;

export const isWaiting = (session) => session.processing_status === 'PENDING';

// Whether to ask the API for this session again: it is waiting, and it was submitted recently.
export const needsRefresh = (session, now = Date.now()) =>
  isWaiting(session) && now - new Date(session.submitted_at).getTime() < REFRESH_FOR_MS;

// The one line under an update that has no summary to show, or null when there is nothing to say.
export function statusLine(session) {
  if (session.processing_status === 'PENDING') {
    return session.recording ? 'Being transcribed and summarised…' : 'Being summarised…';
  }
  if (session.processing_status === 'FAILED') {
    return session.recording
      ? 'This update could not be transcribed. Your recording is saved.'
      : 'This update could not be summarised. Your notes are saved.';
  }
  return null;
}

const LANGUAGES = { en: 'English', fr: 'French' };

// "French" for fr; the code itself for a language the hub was not built for; nothing for none.
export const languageName = (code) => (code ? LANGUAGES[code] ?? code.toUpperCase() : null);

// The transcript's parts in reading order: the English first when the original is not English,
// because that is what most readers want, with the original kept beside it.
export function transcriptParts(transcript) {
  const original = {
    label: languageName(transcript.language) ? `Original (${languageName(transcript.language)})` : 'Original',
    text: transcript.text,
  };
  if (!transcript.english) return [{ label: null, text: transcript.text }];
  return [{ label: 'English translation', text: transcript.english }, original];
}
